'use client';

import { useRouter } from 'next/navigation';
import { isVersion } from '../../../../utils/version';
import styles from './TradeButton.module.scss';

export type TradeButtonProps = {
  version?: string | null;
  isEnabledTrade?: boolean;
  tradeableCount?: number;
  minTradeRequiredCount?: number;
  size: 'small' | 'medium' | 'large' | 'fullWidth';
  lotteryId?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  currentPage?: 'tradeDetail' | 'trade' | 'collection' | 'other';
};

function TradeButton({
  version,
  isEnabledTrade,
  tradeableCount,
  minTradeRequiredCount,
  size,
  lotteryId,
  onClick,
  currentPage = 'other',
}: TradeButtonProps) {
  const router = useRouter();

  // バージョンが2.0未満の場合は表示しない（nullやundefinedの場合も非表示）
  if (!isVersion(version, '2.0')) {
    return null;
  }

  const isEnabled =
    tradeableCount !== undefined && minTradeRequiredCount !== undefined
      ? tradeableCount >= minTradeRequiredCount
      : (isEnabledTrade ?? false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // イベントの伝播を停止（親のLinkがクリックされないようにする）
    e.stopPropagation();

    if (onClick) {
      onClick(e);
      // stopPropagationが呼ばれた場合は、内部ロジックを実行しない
      return;
    }

    if (!isEnabled) return;

    // 現在のページに応じて遷移先を決定
    if (currentPage === 'tradeDetail') {
      // /trade/[lotteryId]の場合は、select-tradeable-prizesに遷移
      //@ts-ignore
      router.push(`/trade/${lotteryId}/select-tradeable-prizes`);
      return;
    }
    if (currentPage === 'trade') {
      // /tradeの場合は、/trade/[lotteryId]に遷移
      //@ts-ignore
      router.push(`/trade/${lotteryId}`);
      return;
    }
    if (currentPage === 'collection') {
      // /獲得景品一覧の場合は/tradeに遷移
      //@ts-ignore
      router.push('/trade');
      return;
    }
    // その他の場合は/trade/[lotteryId]に遷移
    //@ts-ignore
    router.push(`/trade/${lotteryId}`);
    return;
  };

  return (
    <div className={styles.tradeButton}>
      <button className={`${styles.button} ${styles[size]}`} type='button' disabled={!isEnabled} onClick={handleClick}>
        &nbsp;景品を交換する
      </button>
    </div>
  );
}

export default TradeButton;
